export const InsertOffensiveFoulDrawnPlayer = {
  name: "insert-offensive-foul-drawn-player",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "offensiveFoul.defender.select",
  showOn: [{ state: "editState", value: "insert-offensive-foul-drawn-player", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["parent"] },
  children: [
    {
      name: "offensive-foul-drawn-player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      showOn: [true],
      options: {
        currentEntityEvent: "parent",
        currentEntity: false,
        showBench: false,
        showCoach: false,
      },
      actionGroups: [
        {
          actions: [
            { action: "newEventId", value: null, type: "main" },
            {
              action: "saveData",
              value: [{ option: "offensive", value: true }],
              type: "options",
            },
            { action: "sendEvent", value: "edit", type: "main" },
            { action: "nextState", value: null, type: "editState" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
